import { NotificationAlerts } from "@station/domain/models/notification-alert.model";
import type { NotificationAlertRepository } from "@station/domain/repositories/notification-alert.repository";
import { stationsTypes } from "@station/station-types.di.ts";
import { inject, injectable } from "inversify";

@injectable()
export class NotificationAlertGetAllUseCase {
    constructor(
        @inject(stationsTypes.repositories.NotificationAlertRepository)
        private readonly notificationAlertRepository: NotificationAlertRepository,
    ) {}

    async execute(stationId: string): Promise<NotificationAlerts> {
        const notificationAlertResult =
            await this.notificationAlertRepository.getAll(stationId);

        return notificationAlertResult.match(
            (notificationAlerts) => notificationAlerts,
            () => NotificationAlerts.empty(),
        );
    }
}
